import React from 'react';
import { clsx } from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'elevated' | 'glass' | 'premium' | 'active';
  hoverable?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  variant = 'default',
  hoverable = false,
  onClick,
  style
}) => {
  const baseClasses = 'rounded-xl transition-all duration-300 ease-out';
  
  const variantClasses = {
    default: 'bg-background-secondary border border-fieldline',
    elevated: 'glass-effect shadow-lg',
    glass: 'glass-effect-light',
    premium: 'glass-effect shadow-2xl border border-accent-primary/20',
    active: 'bg-background-tertiary border border-fieldline border-l-2 border-l-accent-primary'
  };

  const hoverClasses = hoverable ? 'card-hover cursor-pointer' : '';
  
  return (
    <div
      className={clsx(
        baseClasses,
        variantClasses[variant],
        hoverClasses,
        className
      )}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card; 